import axiosInstance from "../configuration/api";

interface EnquiryData {
  fullName: string;
  email: string;
  phone: string;
  company?: string;
  interest?: string;
  quantity?: string;
  message: string;
  status?: string;
  source?: string;
  productId?: string;
  seriesId?: string;
  pincode?: string;
  address?: string;
}

export const createEnquiry = async (enquiryData: EnquiryData) => {
  try {
    const baseUrl = process.env.REACT_APP_API_HOST;
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/enquiry`,
      enquiryData
    );
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "Failed to submit enquiry"
    );
  }
};

export const createCartEnquiry = async (data: any) => {
  try {
    const baseUrl = process.env.REACT_APP_API_HOST;
    const response = await axiosInstance.post("/api/enquiries/cart", data);
    return response;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message || "Failed to submit enquiry"
    );
  }
};
